import React from 'react';
import { useSelector } from 'react-redux';
import { Badge } from 'antd-v5';
import { AlarmBellIcon } from 'assets/icons';
import { getUserNotifications } from 'domains/user';
import { theme } from 'styles';
import { CenterFlex, Icon } from 'UI';
import { getSearchData } from 'utils';

const NotificationsIconComponent = ({ size = 24 }: { size?: number }) => {
  const notifications = getSearchData(useSelector(getUserNotifications))?.notifications;
  const notificationCount = notifications?.length;
  return (
    <CenterFlex>
      <Badge
        size={'small'}
        count={notificationCount}
        styles={{
          indicator: {
            fontWeight: 'bold',
            padding: '0 3px',
          },
        }}
      >
        <Icon IconComponent={AlarmBellIcon} color={theme.color.brand_black} size={size} display={'block'} />
      </Badge>
    </CenterFlex>
  );
};

export default NotificationsIconComponent;
